import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { connect } from "react-redux";
import { callsPlayer } from "../../actions/Calls";

const CallsPlayer = ({ id = '', type = '', callsPlayer }) => {
  const [modal, setModal] = useState(false);
  const token = localStorage.getItem('jwtToken');
  const toggle = () => setModal(!modal);

  return (
    <>
      <div>
        <Button color="secondary" onClick={toggle}>Play</Button>
        <Modal isOpen={modal} toggle={toggle}>
          <ModalHeader toggle={toggle}>Listening to the call</ModalHeader>
          <ModalBody style={{ display: 'flex', justifyContent: 'center' }}>
            {
              modal &&
              <audio
                id="audio"
                src={callsPlayer(token, id, type)}
                preload="auto"
                controls
                muted={false}
                loop={false}
                autoPlay
              >
              </audio>
            }
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  callsPlayer
};

export default connect(null, mapDispatchToProps)(CallsPlayer);
